export default {
    data() {
        return {
            search_order_status: "",
            search_step: "",
        };
    },
    methods: {
        on_step_change() {},
        on_status_change() {},
        load_stat() {
            this.$http.get(`/order_trademark/stat`).then((res) => {
                if (res.success) {
                    this.$store.commit("change_state", { name: "stat_order", value: res.data });
                }
            });
        },
        on_distribute(item) {
            let user_id = item.length === 1 ? item[0].user_id : null;
            let callback = () => {
                this.load();
                this.selected_row_keys = [];
            };

            this.$event_bus.$emit("visible_order_distribute", item, user_id, callback);
        },
        on_order_bind(callback) {
            this.$event_bus.$emit("visible_order_bind", callback);
        },
    },
};
